import React, { useEffect, useState } from "react";
import { Input } from "@material-ui/core";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

interface IDocumentInformation {
    id: string;
    name: string;
    size: number;
    documentType: string;
    uploaded: Date;
}

export const DocumentList: React.FunctionComponent = (): React.ReactElement => {
    const [documents, setDocuments] = useState([]),
        [isAdmin, setIsAdmin] = useState<boolean>(false),
        [errorMsg, setErrorMsg] = useState<string>("");

    useEffect((): void => {
        void getInfo();
        void getPermissions();
    }, []);

    const getInfo = async (): Promise<void> => {
        const stringResult: string = await $.ajax(
            `/CentralDocumentRepository/GetDocuments`,
            { method: `GET` },
        );

        const result: IDocumentInformation[] = JSON.parse(stringResult);

        setDocuments([...result]);
    };

    const getPermissions = async (): Promise<void> => {
        setIsAdmin(
            (await $.ajax(`/CentralDocumentRepository/HasPermissions`, {
                method: `GET`,
            })) === `True`,
        );
    };

    const handleFileUpload = (
        element: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        const file: File = element.currentTarget.files[0],
            formData: FormData = new FormData();

        if (!file) {
            return;
        } else if (file.type.length === 0) {
            setErrorMsg("Please upload a valid file type");
            return;
        } else if (file.size >= 8000000) {
            setErrorMsg("File too large, max file size is 8MB");
            return;
        }
        formData.append(`file`, file);

        void $.ajax({
            cache: false,
            contentType: false,
            data: formData,
            method: `post`,
            processData: false,
            success() {
                void getInfo();
            },
            url: `/CentralDocumentRepository/PostFile`,
        });
        setErrorMsg("");
    };

    const handleFileDownload = (guid: string): void => {
        window.location.href = `/CentralDocumentRepository/DownloadFile?guid=${guid}`;
    };

    const handleFileDelete = (guid: string): void => {
        void $.ajax({
            method: `post`,
            success() {
                void getInfo();
            },
            url: `CentralDocumentRepository/Delete?guid=${guid}`,
        });
    };

    return (
        <div
            style={{
                display: `flex`,
                flexDirection: `column`,
                minWidth: `500px`,
            }}
        >
            {documents.length > 0 ? (
                <div className={`centralDocumentRepository-list`}>
                    <div
                        className={`scroll centralDocumentRepository-scrollable`}
                    >
                        {documents.map((d) => (
                            <div
                                className={`centralDocumentRepository-document`}
                                key={d.Id}
                            >
                                <div
                                    className={`centralDocumentRepository-details`}
                                >
                                    <span className={`wrap`}>
                                        <h4 className={`overflow`}>{d.Name}</h4>
                                        <span className={`tooltip`}>
                                            {d.Name}
                                        </span>
                                    </span>
                                    {d.DocumentType ?? (
                                        <span>{d.DocumentType}</span>
                                    )}
                                    <span>
                                        Uploaded{" "}
                                        {new Date(d.Uploaded).toLocaleString()}
                                    </span>
                                    <span>Size: {d.Size} MB </span>
                                </div>
                                <div
                                    className={`centralDocumentRepository-icon`}
                                >
                                    <img
                                        onClick={(): void =>
                                            handleFileDownload(d.Id)
                                        }
                                        src={`/Images/Document_Download.svg`}
                                    />
                                </div>
                                {isAdmin && (
                                    <div
                                        className={`centralDocumentRepository-icon`}
                                    >
                                        <img
                                            onClick={(): void =>
                                                handleFileDelete(d.Id)
                                            }
                                            src={`/Images/Document_Bin.svg`}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className={`centralDocumentRepository-list`}>
                    <p>No documents have been uploaded.</p>
                </div>
            )}

            {isAdmin && (
                <div style={{ display: `flex`, flexDirection: `column` }}>
                    {errorMsg.length > 0 && (
                        <p style={{ margin: `0 auto` }}> {errorMsg} </p>
                    )}
                    <div className={`centralDocumentRepository-uploadButton`}>
                        <label className={`centralDocumentRepository-upload`}>
                            <Input
                                onChange={handleFileUpload}
                                style={{ display: `none` }}
                                type={`file`}
                            />
                            Upload
                        </label>
                    </div>
                </div>
            )}
        </div>
    );
};
